<template>
    <div class="workers">
        <div class="workers__peon workers__peon--gold" v-for="(worker, index) in $store.state.goldWorkers" :key="'gold' + index">
            <div class="workers__icon"
                 :class="{ 'workers__icon--return': worker.percent > 50 }"></div>
            <div class="workers__progress">
                <div class="workers__progress-inner" :style="{ width: Math.ceil(worker.percent) + '%' }"></div>
            </div>
        </div>

        <div class="workers__peon workers__peon--wood" v-for="(worker, index) in $store.state.woodWorkers" :key="'wood' + index">
                <div class="workers__icon"
                 :class="{ 'workers__icon--return': worker.percent > 50 }"></div>
            <div class="workers__progress">
                <div class="workers__progress-inner" :style="{ width: Math.ceil(worker.percent) + '%' }"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Workers"
    }
</script>

<style lang="scss" scoped>
    .workers {
        &__peon {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            &--gold {
                .workers__progress-inner {
                    background: theme('colors.yellow.700');
                }

                .workers__icon {
                    width: 36px;
                    height: 41px;
                    animation: peon 1s steps(5) infinite;
                    background: url('../assets/images/PeonSprite.png') top center no-repeat;

                    &--return {
                        background-image: url('../assets/images/GoldWorkerSprite.png');
                    }
                }
            }

            &--wood {
                .workers__progress-inner {
                    background: theme('colors.green.700');
                }

                .workers__icon {
                    width: 36px;
                    height: 41px;
                    animation: peon 1s steps(5) infinite;
                    background: url('../assets/images/PeonSprite.png') top center no-repeat;

                    &--return {
                        background-image: url('../assets/images/WoodWorkerSprite.png');
                    }
                }
            }
        }

        &__icon-wrapper {
            width: 40px;
        }

        &__progress {
            flex: 1;
            height: 2rem;
            padding-left: .5rem;
        }

        &__progress-inner {
            height: 100%;
        }
    }

    @keyframes peon {
        100% {
            background-position: 0 -205px;
        }
    }
</style>